import { Button } from '@/components/Button/Button';
import { Select } from '@/components/Select/Select';
import { TextField } from '@/components/TextField/TextField';
import type { FileFilters } from './FileFilterBar.types';

import styles from './FileFilterBar.module.css';

export interface FileFilterBarProps {
  filters: FileFilters;
  onChange: (filters: FileFilters) => void;
  onReset: () => void;
}

export function FileFilterBar({ filters, onChange, onReset }: FileFilterBarProps) {
  const set = <K extends keyof FileFilters>(key: K, value: FileFilters[K]) =>
    onChange({ ...filters, [key]: value });

  return (
    <div className={styles.bar}>
      <Select
        label="Status"
        onChange={(value) => set('status', value as FileFilters['status'])}
        options={[
          ['', 'Any status'],
          ['VALIDATED', 'Validated'],
          ['PENDING', 'Pending (bytes never arrived)'],
        ]}
        value={filters.status}
      />

      <Select
        label="app-api reference"
        onChange={(value) => set('appApiRef', value as FileFilters['appApiRef'])}
        options={[
          ['any', 'Any'],
          ['present', 'Has a reference'],
          ['absent', 'Keystone only'],
        ]}
        value={filters.appApiRef}
      />

      <Select
        label="Origin"
        onChange={(value) => set('origin', value as FileFilters['origin'])}
        options={[
          ['any', 'Any origin'],
          ['migrated', 'Migrated from app-api'],
          ['uploaded', 'Uploaded to Keystone'],
        ]}
        value={filters.origin}
      />

      <Select
        label="Canonical PDF"
        onChange={(value) => set('canonical', value as FileFilters['canonical'])}
        options={[
          ['any', 'Any'],
          ['present', 'Has one'],
          ['absent', 'Has none'],
        ]}
        value={filters.canonical}
      />

      <Select
        label="Bindery job"
        onChange={(value) => set('canonicalization', value as FileFilters['canonicalization'])}
        options={[
          ['', 'Any job state'],
          ['NONE', 'No job at all'],
          ['PENDING', 'Pending (undispatched)'],
          ['DISPATCHED', 'Dispatched'],
          ['COMPLETE', 'Complete'],
          ['FAILED', 'Failed'],
        ]}
        value={filters.canonicalization}
      />

      <TextField
        label="app-api id"
        onChange={(event) => set('extAppApiId', event.target.value)}
        placeholder="doc_9001"
        value={filters.extAppApiId}
      />

      <div className={styles.actions}>
        <Button onClick={onReset} type="button" variant="ghost">
          Reset
        </Button>
      </div>
    </div>
  );
}
